/**
 * Medya URL'lerinin mutlaklaştırılması.
 *
 * ADR-012 Faz 4b: İstemci artık medya jetonu **üretmez/önbelleklemez**.
 * Sunucu, API yanıtlarındaki tüm medya URL'lerini öğe kapsamlı imzalar.
 * Web/PWA'da jeton zaten gerekmez (HttpOnly oturum çerezi).
 */
import { apiUrl } from './apiBase.ts';

/** Medya yolunu API origin'ine taşır; jeton eklemez. */
export function mediaUrl(path: string): string {
  return apiUrl(path);
}

/**
 * Native Media3 bildirimi için **mutlak** kapak URL'si.
 *
 * Media3 yalnız `http(s)` adreslerini indirebilir; Capacitor WebView'ında
 * göreli yollar uygulamanın kendi origin'ine gider. Paketlenmiş istemcide
 * API tabanı mutlaktır.
 */
export function mediaArtworkUrl(path: string | null | undefined): string | null {
  if (path === null || path === undefined || path === '') return null;
  const url = apiUrl(path);
  return /^https?:\/\//i.test(url) ? url : null;
}
